/**
 * Internal dependencies
 */
import reducer from './reducer';
import * as types from './types';
import * as actions from './actions';
import * as selectors from './selectors';
import * as constants from './constants';
import * as proptypes from './proptypes';

export default reducer;
export { types, actions, selectors, constants, proptypes };
